import axios from "@/helpers/axios";

const base_url = process.env.VUE_APP_API_BASEURL;

async function list(params) {
  return axios.get(`${base_url}oem-clients`, { params }).then((response) => {
    return response.data;
  });
}

async function show(oemCLient) {
  return axios
    .get(`${base_url}oem-clients/${oemCLient.id}`)
    .then((response) => {
      return response.data;
    });
}

async function add(oemCLient) {
  return axios
    .post(`${base_url}oem-clients`, oemCLient, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      return response.data;
    });
}

async function update(oemCLient) {
  return axios
    .post(`${base_url}oem-clients/${oemCLient.id}`, {...oemCLient,"_method":"put"}, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      return response.data;
    });
}

async function destroy(oemCLient) {
  return axios
    .delete_method(`${base_url}oem-clients/${oemCLient.id}`)
    .then((response) => {
      return response.data;
    });
}

export default {
  list,
  show,
  add,
  update,
  destroy,
};
